"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var Wonka = __importStar(require("wonka"));
var makeNetworkSource = function (operation, client) {
    return Wonka.make(function (_a) {
        var next = _a.next, complete = _a.complete;
        var cancelToken = axios_1.default.CancelToken.source();
        var request = client.project.axios.request(__assign(__assign({}, operation.request), { cancelToken: cancelToken.token, url: operation.request.url }));
        request
            .then(function (resp) {
            next({ data: resp.data, operation: operation, stale: false });
        })
            .catch(function (error) {
            next({ error: error, operation: operation, stale: false });
        })
            .finally(function () {
            complete();
        });
        return function () {
            cancelToken.cancel();
        };
    });
};
var isTeardown = function (operation) { return operation.type === "teardown"; };
var networkExchange = function (_a) {
    var forward = _a.forward, client = _a.client;
    return function (operationStream) {
        var sharedOpsStream = Wonka.share(operationStream);
        var resultsStream = Wonka.pipe(sharedOpsStream, Wonka.filter(function (operation) { return !isTeardown(operation); }), Wonka.mergeMap(function (operation) {
            var key = operation.key;
            var teardownStream = Wonka.pipe(sharedOpsStream, Wonka.filter(function (op) { return op.type === "teardown" && op.key === key; }));
            return Wonka.pipe(makeNetworkSource(operation, client), Wonka.takeUntil(teardownStream));
        }));
        var forwardStream = Wonka.pipe(sharedOpsStream, Wonka.filter(function (operation) { return isTeardown(operation); }), forward);
        return Wonka.merge([resultsStream, forwardStream]);
    };
};
exports.default = networkExchange;
